import { combineDucks } from "lib/utils/duck";

import AffiliateListView from "./AffiliateListView/index";

export default combineDucks({
  AffiliateListView,
});



// WEBPACK FOOTER //
// ./src/modules/affiliate/index.js